import { Component, Inject, OnInit, ViewChildren, QueryList, ElementRef, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { environment } from 'environments/environment';
import { GeneralDialog } from '../GeneralDialog/general-dialog';
import { Subscription, BehaviorSubject } from 'rxjs';
import { VehiclesService } from 'app/_services/vehicles.service';
import { map, flatMap, concatMap, takeUntil, mergeMap } from 'rxjs/operators';
import { Deck } from '@deck.gl/core';
// import { GoogleMapsOverlay } from '@deck.gl/google-maps';
import { PathLayer, IconLayer, TripsLayer } from '@deck.gl/layers';
import { interval } from 'rxjs/observable/interval';
import { timer } from 'rxjs/observable/timer';
import { forkJoin } from 'rxjs/observable/forkJoin';

export interface IVideoLiveSnaphotData {
  vehicleID: number;
  stationary: boolean;
  newStream: boolean;
  registration: string;
}
export interface IVideoLiveSnapshot {
  Altitude: number;
  Camera: number;
  EndDateTime: string;
  Heading: number;
  Latitude: number;
  Longitude: number;
  MDTURL: string;
  Speed: number;
  StartDateTime: string;
  URL: string;
}
export interface VideoState {
  video: IVideoLiveSnapshot[];
  channelCount: number;
  interval: number;
  loading: boolean;
}
let _state: VideoState = {
  video: [],
  channelCount: 1,
  interval: 0,
  loading: false
};

/**
 * @title Dialog for video requests on the video activity page
 */

@Component({
  selector: 'video-live-snapshot-dialog',
  templateUrl: 'video-live-snapshot-dialog.html',
  styleUrls: [
    "./video-live-snapshot-dialog.scss"
  ]
})

export class VideoLiveSnapshotDialog implements OnInit, AfterViewInit {

  @ViewChildren('cameraViewport') cameraViewports: QueryList<ElementRef>;
  public intervals = 0;

  @ViewChild('videoEl') private videoEl: any;

  private _videoStream$ = new BehaviorSubject<VideoState>(_state);
  public dataStore: VideoState = _state;
  readonly videoStream$ = this._videoStream$.asObservable();

  public smartWitnessUrl: string = environment.smartWitnessBaseUrl;
  videoRequestApiSubscription$: Subscription;
  videoIntervalApiSubscription$: Subscription;

  public isPaused = false;
  public videoMainSrc = null;
  public videoMainIndex = 0;

  mapRef: any = null;
  overlay = null;
  lat: number = 0;
  long: number = 0;
  zoom: number = 16;
  lastHeading = 0;
  videoLinkStore: IVideoLiveSnapshot[][] = [];

  styles: any = [{ featureType: 'all', stylers: [{ saturation: -80 }] }, {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [{ hue: '#00ffee' }, { saturation: 50 }]
  }];

  trail: { lat: number, long: number, dir: number, timestamp: number }[] = [];

  public loadingMessage = 'Connecting to device...';
  liveVideoInterval: NodeJS.Timer;

  mediaSource: MediaSource;
  unsubFromPending = new EventEmitter();
  autoScroll: boolean = false;

  constructor(
    private vehiclesService: VehiclesService,
    public dialogRef: MatDialogRef<VideoLiveSnapshotDialog>,
    @Inject(MAT_DIALOG_DATA) public data: IVideoLiveSnaphotData) {
  }

  ngAfterViewInit() {
  }

  ngOnInit() {
    console.log('Data of snapshot: ', this.data.vehicleID);
    console.log('Data of snapshot: ', this.data.newStream);

    this.setupDummyLoadingMessages();

    if (this.data.newStream) {
      // WE ARE NOW USING THE NEW ENDPOINT FOR THE VEHICLE CHUNKS OF VIDEO DATA
      // THIS SHOULD BE FAST ENOUGH TO REQUEST 30 SECONDS AT A TIME OR A MINUTES

      // setup a media source for buffering
      // this.mediaSource = new MediaSource();


      this.getVideosOnInterval();
    } else {

      this.videoRequestApiSubscription$ = this.vehiclesService.getVehicleLiveSnapshotJpg(this.data.vehicleID)
        .subscribe((video: IVideoLiveSnapshot[]) => {
          if (video instanceof Array) {
            this.loadingMessage = '';

            // This finds the amount of dummy inactive cameras we need to add to round of the 4x4 rows.
            const roundUpCameras = (Math.ceil(video.length / 4) * 4) - video.length;
            for (let i = 0; i < roundUpCameras; i++) {
              video.push({} as any);
            }
            console.log('Videos Loaded', video.length)

            this.dataStore.video = video;
            this.dataStore.channelCount = video.length;
            this.dataStore.loading = false;
            console.log('Data', this.dataStore);
            this._videoStream$.next(Object.assign({}, this.dataStore));
            this.updateVehicleTrail(video[0]);
            this.getVideosOnInterval();

          } else {
            this.loadingMessage = 'Video request timed out';
          }
        }, errData => {
          console.log(errData);
          this.loadingMessage = 'Could not connect to the device. PLease try again';
        });
    }
  }

  /**
   * generates a random wait time to simulate a request
   */
  getRandomWaitTime(): number {
    return Math.floor(Math.random() * (1000 - 2500 + 1) + 2500);
  }

  setupDummyLoadingMessages() {
    setTimeout(() => {
      if(this.loadingMessage === 'Connecting to device...') {
        this.loadingMessage = 'Initializing Video...';
      }

      setTimeout(() => {
        if(this.loadingMessage === 'Initializing Video...') {
          this.loadingMessage = 'Encrypting Video...'
        }
      }, this.getRandomWaitTime());
    }, this.getRandomWaitTime());
    
  }


  /**
   * takes live video data and sets it up for the component to 
   * render the video
   */
  private async liveVideoSetupBuffer(video: IVideoLiveSnapshot[]) {
    // This finds the amount of dummy inactive cameras we need to add to round of the 4x4 rows.
    this.loadingMessage = '';

    const roundUpCameras = (Math.ceil(video.length / 4) * 4) - video.length;
    for (let i = 0; i < roundUpCameras; i++) {
      video.push({} as any);
    }

    this.videoLinkStore.push([...video]);

    if (this.dataStore.video.length === 0) {
      this.setVideoAtNewBuffer();
    } else if(this.videoEndedWaiting) {
      this.videoEndedWaiting = false;
      const videos = this.videoLinkStore.shift();
      this.dataStore.video = videos.map((video: IVideoLiveSnapshot) => ({ ...video, URL: `${this.smartWitnessUrl}${video.URL}` }));
    }

    this.updateVehicleTrail(video[0]);

    // video.forEach((e) => {
    //   this.preloadVideo(`${this.smartWitnessUrl}${e.URL}`);
    // })
  }

  videoEndedWaiting = false;

  endVideo() {
    console.log('## VIDEO HAS ENDED',)
    // if (!this.autoScroll) {
    if (this.videoLinkStore.length === 0) {
      this.videoEndedWaiting = true;
    } else {
      this.setVideoAtNewBuffer();
    }
      // return; 
    // }
 
    // if (this.videoMainIndex + 1 === this.dataStore.video.length) {
    //   this.setVideoAtNewBuffer();
    // } else if (this.videoMainIndex + 1 < this.dataStore.video.length) {
    //   this.videoMainIndex++;
    // }
  }

  setVideoAtNewBuffer() {
    const newVideo = this.videoLinkStore.shift();

    if (newVideo) {
      this.dataStore.video = newVideo.map((video: IVideoLiveSnapshot) => ({ ...video, URL: `${this.smartWitnessUrl}${video.URL}` }));
      this.dataStore.channelCount = newVideo.length;
      this.dataStore.loading = false;

      this._videoStream$.next(Object.assign({}, this.dataStore));

      this.videoMainSrc = this.dataStore.video[this.videoMainIndex].URL;
    }
  }

  getVideosOnInterval() {
    if (!this.data.newStream) {
      this.videoIntervalApiSubscription$ = timer(0, 800)
        .pipe(concatMap(val => this.vehiclesService.getVehicleLiveSnapshotJpg(this.data.vehicleID)))
        .subscribe((video: IVideoLiveSnapshot[]) => this.onNewVideoData(video));
    } else {
      console.log('Fetching Live Video...');
      this.videoIntervalApiSubscription$ = timer(0, 10000)
        .mergeMap(val => this.vehiclesService.getVehicleLive(this.data.vehicleID))
        .subscribe((res: IVideoLiveSnapshot[]) => {
          console.log(res);
          if (res && res.length) {
            this.liveVideoSetupBuffer(res);
          } else {
            alert('Error getting video');
          }
        });
    }
  }

  onVideoLoaded($event) {
    console.log($event.target);
  }


  onNewVideoData(video: IVideoLiveSnapshot[]) {
    if (!(video instanceof Array)) {
      this.loadingMessage = 'Video request timed out...';
      return;
    }

    const roundUpCameras = (Math.ceil(video.length / 4) * 4) - video.length;
    for (let i = 0; i < roundUpCameras; i++) {
      video.push({} as any);
    }

    if (this.intervals === 0) {
      this._videoStream$.next(Object.assign({}, this.dataStore));
      this.dataStore.loading = false;
    }

    this.loadingMessage = '';
    this.dataStore.video = video;
    this.dataStore.channelCount = video.length;

    this.intervals++;
    this.updateVehicleTrail(video[0]);
    this.loadImages(this.dataStore.video);
  }

  onMapReady(mapInstance: any) {
    // Get a reference to the map.
    console.log('Map Ref', mapInstance);
    this.mapRef = mapInstance;
    this.drawMapTrail();
  }

  drawMapTrail() {
    let path = this.trail.map((x) => {
      return [x.long, x.lat];
    });
    let deckTrips = this.trail.map((x) => {
      return {
        timestamp: x.timestamp,
        position: [x.long, x.lat],
      };
    });

    if (path.length === 0) { return; }

    const lastPos = this.trail[this.trail.length - 1];

    if (lastPos.dir !== 0) {
      // if the camera has no movement it sends 0 as it's dir which isn't always correct.
      this.lastHeading = 360 - lastPos.dir;
    }

    const dataPath = [].concat.apply([], path);
    const position = new google.maps.LatLng(dataPath[dataPath.length - 1], dataPath[dataPath.length - 2]);
    this.mapRef.panTo(position);

    // Icon Layer
    const iconLayer = new IconLayer({
      id: 'icon-layer',
      data: [{
        position: [lastPos.long, lastPos.lat],
        direction: this.lastHeading,
        icon: {
          url: '/assets/images/icons/deck-icon.png',
          width: 128,
          height: 128,
          anchorY: 64
        }
      }],
      pickable: false,
      getAngle: d => d.direction,
      getIcon: d => d.icon,
      sizeScale: 8,
      getPosition: d => d.position,
      getSize: d => 5
    });

    // Path layer
    const pathLayer = new PathLayer({
      id: 'trail-path',
      data: [{
        path: dataPath,
        color: [197, 79, 151]
      }],
      widthScale: 1,
      widthMinPixels: 8,
      getPath: d => d.path,
      getColor: d => d.color,
      getWidth: d => 1,
      positionFormat: `XY`,
      rounded: true,
      pickable: false
    });

    if (!this.overlay) {
      this.overlay = new GoogleMapsOverlay({});
      this.overlay.setMap(this.mapRef);
    }
    this.overlay.setProps({
      layers: [
        pathLayer,
        // tripsLayer,
        iconLayer]
    });
  }

  updateVehicleTrail(data: IVideoLiveSnapshot) {
    this.trail.push({
      lat: data.Latitude,
      long: data.Longitude,
      dir: data.Heading,
      timestamp: new Date(data.EndDateTime).getTime()
    });

    if (this.mapRef) {
      this.drawMapTrail();
    }
  }

  selectNewMainStream(index: number) {
    this.videoMainIndex = index;
    if (!this.data.newStream) {
      this.videoMainSrc = this.cameraViewports.toArray()[index].nativeElement.src;
    } else {
      this.videoMainSrc = this.dataStore.video[index].URL;
      this.autoScroll = false;
    }
    this.videoEndedWaiting = false;
  }

  loadImages(images: any[]) {
    let i = 0;
    this.cameraViewports.forEach((viewport) => {
      if (images[i]) {
        this.preloadImage(images[i].URL, viewport.nativeElement);
      } else {
        viewport.nativeElement.src = null;
      }

      i++;
    });
    this.videoMainSrc = `${this.smartWitnessUrl}${images[this.videoMainIndex].URL}`;
  }

  async preloadImage(src, elem: HTMLImageElement) {
    const img = new Image();
    img.addEventListener('load', () => {
      elem.src = `${this.smartWitnessUrl}${src}`;
    });
    img.src = `${this.smartWitnessUrl}${src}`;
  }

  async preloadVideo(src) {
    const videoElement = document.createElement('video');
    console.log('[Video] 🔃 Loading...');
    videoElement.addEventListener('canplaythrough', () => {
      console.log('[Video] ✅ Loaded.');
      videoElement.remove();
    });
    videoElement.preload = 'auto';
    videoElement.src = src;
  }

  stopLiveVideo() {
    if (this.videoIntervalApiSubscription$) {
      this.videoIntervalApiSubscription$.unsubscribe();
    }

    clearInterval(this.liveVideoInterval);
    this.unsubFromPending.next();

    setTimeout(() => {
      this.resetState();
      this.dialogRef.close();
    }, 1);
  }

  onPause() {
    this.isPaused = true;
    if (this.videoIntervalApiSubscription$) {
      this.videoIntervalApiSubscription$.unsubscribe();
    }
  }

  onResume() {
    this.isPaused = false;
    this.getVideosOnInterval();
  }

  private resetState() {
    this.dataStore.video = [];
    this.dataStore.channelCount = 1;
    this.dataStore.interval = 0;
    this.dataStore.loading = false;
    this._videoStream$.next(Object.assign({}, this.dataStore));
  }

  /** Update internal state cache and emit from store... */
  private updateState(state: VideoState) {
    //this.store.next(_state = state);
  }


}





// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/Dialogs/VideoLiveSnapshotDialog/video-live-snapshot-dialog.ts